'use client'

import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import Link from 'next/link'
import React, { useEffect, useMemo, useState } from 'react'
import Confetti from 'react-confetti'
import useWindowSize from 'react-use/lib/useWindowSize'

interface AnnouncementBannerProps {
  message?: string
  backgroundColor?: string
  textColor?: string
  link?: string
  enableConfetti?: boolean
}

const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({
  message = '🎉 Special announcement: New features available now!',
  backgroundColor = '#1976d2',
  textColor = 'white',
  link = '/',
  enableConfetti = false
}) => {
  const { height } = useWindowSize()
  const [showConfetti, setShowConfetti] = useState(enableConfetti)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (enableConfetti) {
      const timer = setTimeout(() => {
        setShowConfetti(false)
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [enableConfetti])

  const confettiWidth = useMemo(() => {
    if (typeof window === 'undefined') return 0
    return window.innerWidth
  }, [])

  if (!isVisible) return null

  return (
    <div className="relative w-full">
      {enableConfetti && confettiWidth > 0 && (
        <Confetti
          width={confettiWidth}
          height={height}
          recycle={showConfetti}
        />
      )}
      <div
        style={{
          backgroundColor,
          color: textColor,
          padding: '10px 20px',
          textAlign: 'center',
          position: 'relative',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 600,
          zIndex: 1000
        }}>
        <Link
          href={link}
          style={{
            flex: 1,
            color: textColor,
            fontWeight: 600,
            textDecoration: 'none'
          }}>
          <div>{message}</div>
        </Link>
        <IconButton
          size="small"
          onClick={() => setIsVisible(false)}
          style={{ color: textColor, padding: '4px' }}
          aria-label="close announcement">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  )
}

export default AnnouncementBanner
